import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "zero mt-3" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h4" }, "Account Verification")
], -1)
const _hoisted_2 = { class: "container animated fadeIn" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("p", null, "We Need to Verify Your Account.")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "col-3" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "col-lg-6 col-md-6 col-sm-12 col-12 alert alert-warning m-2",
  role: "alert"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("h5", { class: "alert-heading" }, "Message:", -1)
const _hoisted_8 = {
  key: 0,
  class: "row justify-content-center"
}
const _hoisted_9 = {
  key: 0,
  class: "col-12"
}
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Your account has been rejected. You can try again, ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" click here ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" to make any changes. Please contact us by email at ")
const _hoisted_14 = /*#__PURE__*/_createVNode("a", { href: "mailto:info@satstreet.com" }, "info@satstreet.com", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" if you have any questions. ")
const _hoisted_16 = {
  key: 1,
  class: "col-12"
}
const _hoisted_17 = { class: "text-muted" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Your account is being verified, we will send you an email once the account has been approved. Please contact us by email at ")
const _hoisted_19 = /*#__PURE__*/_createVNode("a", { href: "mailto:info@satstreet.com" }, "info@satstreet.com", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" if you have any questions. You can also ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("click here ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" to make any changes. ")
const _hoisted_23 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_24 = { class: "col-lg-12 col-md-12 col-sm-12 shadow p-3 mb-5 rounded" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Manual Verification")
  ]),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "Complete your profile"),
    /*#__PURE__*/_createVNode("li", null, "Upload your ID"),
    /*#__PURE__*/_createVNode("li", null, "Upload your proof of address"),
    /*#__PURE__*/_createVNode("li", null, "Wait for your approval")
  ])
], -1)
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = {
  key: 0,
  class: ""
}
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "text-muted" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-info" }, "In verification process")
], -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("button", { class: "btn btn-success mt-4 text-white" }, "Start now!", -1)
const _hoisted_30 = {
  key: 0,
  class: "col-12"
}
const _hoisted_31 = { class: "text-muted" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Your account is being verified, we will send you an email once the account has been approved. Please contact us by email at ")
const _hoisted_33 = /*#__PURE__*/_createVNode("a", { href: "mailto:info@satstreet.com" }, "info@satstreet.com", -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" if you have any questions. You can also ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("click here ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" to make any changes. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        (_ctx.showMessage)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("p", null, _toDisplayString(_ctx.userProfile.comments), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.userProfile.corporate)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            (_ctx.userProfile.manualVerificationStep === 3)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode("p", _hoisted_10, [
                    _createVNode("strong", null, [
                      _hoisted_11,
                      _createVNode(_component_router_link, { to: { name: 'verify.company' } }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.userProfile.manualVerificationStep === 1)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("p", _hoisted_17, [
                    _createVNode("strong", null, [
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20,
                      _createVNode(_component_router_link, {
                        to: {
                name: _ctx.userProfile.corporate ? 'verify.company' : 'verify.one'
              }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _hoisted_22
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode("div", _hoisted_26, [
                (_ctx.userProfile.manualVerificationStep === 1)
                  ? (_openBlock(), _createBlock("strong", _hoisted_27, [
                      _hoisted_28
                    ]))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: { name: 'verify.one' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_29
                      ]),
                      _: 1
                    }, 8, ["to"]))
              ])
            ]),
            (_ctx.userProfile.manualVerificationStep === 1)
              ? (_openBlock(), _createBlock("div", _hoisted_30, [
                  _createVNode("p", _hoisted_31, [
                    _createVNode("strong", null, [
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _createVNode(_component_router_link, {
                        to: {
                name: _ctx.userProfile.corporate ? 'verify.company' : 'verify.one'
              }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_35
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _hoisted_36
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
    ])
  ], 64))
}